import { vm } from '@main';

import { DateValue } from '@common/types/DateValue';

export class EntryField {
    public id?: number;
    public taskStepId: number;
    public value?: string | number | DateValue;
    public name: string;
    public taskStepTypeName: string;
    public type: string;
    public files: string[];

    constructor(data?: any) {
        this.id = data?.id;
        this.taskStepId = data?.taskStepId;
        this.taskStepTypeName = data?.taskStepTypeName || '';
        this.name = data?.name || '';
        this.type = data?.type || '';
        this.files = data?.files || [];
        if (data?.value && this.type === 'enter_date') {
            this.value = DateValue.fromRequestDateTime(data.value);
        } else {
            this.value = data?.value;
        }
    }

    get valueToString(): string | null {
        // To ignore TS errors, because each field has different value types
        const value: any = this.value;
        if (!value) {
            return '';
        }
        switch (this.type) {
            case 'choose_answer': {
                return `${value.map((v) => ' ' + v.text)}`;
            }
            case 'choose_one_answer': {
                return `${value?.text || ''}`;
            }
            case 'choose_product': {
                return `${value?.name?.[vm.$i18n?.locale] || value?.name?.en || ''}`;
            }
            case 'enter_amount': {
                const amount = value?.amount;
                const unit = value?.unit?.short_name;
                return `${amount || ''}${amount ? ' ' + unit : ''}`;
            }
            case 'choose_partner':
            case 'enter_text': {
                return `${value}`;
            }
            case 'enter_value': {
                const amount = value?.amount;
                const unit = value?.unit;
                return `${amount || ''}${amount ? ' ' + unit : ''}`;
            }
            case 'enter_temperature': {
                const temp = value?.temp;
                const unit = value?.unit?.unit;
                return `${temp || ''}${temp ? ' ' + unit : ''}`;
            }
            case 'enter_date':
                return value;
            case 'yes_no_answer': {
                return vm.$t(value);
            }
            case 'ticket': {
                return '';
            }
            case 'attach_file':
            default: {
                return null;
            }
        }
    }

    toJSON() {
        const json = {
            task_step_id: this.taskStepId,
            value: this.value instanceof DateValue ? this.value.requestDateTimeFormat : this.value || null,
        };

        this.id ? (json['id'] = this.id) : null;

        return json;
    }

    static fromJSON(json: any) {
        return new EntryField({
            id: json?.id,
            taskStepId: json?.task_step_id,
            value: json?.value,
            name: json?.name || json?.step_name,
            type: json?.type,
            files: json?.file_list,
        });
    }

    static stringify(field: EntryField): String {
        const name = field.name ? `${field.name.substr(0, 1).toUpperCase()}${field.name.substr(1)}: ` : '';
        return field.valueToString ? `${name}${field.valueToString}` : '';
    }
}
